/* eslint-disable */
export default {
  sureToDeleteVoiceMail: 'Tem certeza de que deseja excluir esta caixa postal?',
  sureToDeleteFax: 'Tem certeza de que deseja excluir este fax?',
  doNotAskAgain: 'Não perguntar novamente',
} as const;

// @key: @#@"sureToDeleteVoiceMail"@#@ @source: @#@"Are you sure you want to delete this voicemail?"@#@
// @key: @#@"sureToDeleteFax"@#@ @source: @#@"Are you sure you want to delete this fax?"@#@
// @key: @#@"doNotAskAgain"@#@ @source: @#@"Don't ask me again"@#@
